module.exports = __webpack_public_path__ + "img/camera.18907ede.svg";